import { render, staticRenderFns } from "./AdminSubCategoriesAdd.vue?vue&type=template&id=e88c8c2c&"
import script from "./AdminSubCategoriesAdd.vue?vue&type=script&lang=js&"
export * from "./AdminSubCategoriesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports